import { useEffect, useState } from "react";
import { getFeatureStatus } from "../CommonUtils";
import { FEATURES } from "../constants/CommonConstants";

/**
 * Returns true when the CSV export buttons should be disabled ("dialed down") for the current node.
 *
 * Reads the node-aware `isCsvExportDialedDown` flag from the Boson parent (evaluated against the
 * current stationCode). Negative polarity is deliberate: a missing/undeployed flag resolves to
 * false, so false = enabled and CSV is disabled only on an explicit true for the node — a parent
 * error or undeployed flag never disables CSV for everyone. When true the button stays visible but
 * greyed out and unclickable, with a tooltip explaining it is temporarily disabled.
 */
export const useIsCsvExportDialedDown = () => {
    const [dialedDown, setDialedDown] = useState(false);

    useEffect(() => {
        let isMounted = true;
        getFeatureStatus(FEATURES.IS_CSV_EXPORT_DIALED_DOWN)
            .then(status => {
                if (isMounted) {
                    setDialedDown(status === true);
                }
            })
            .catch(() => {
                // Fail open: keep CSV visible on parent error/timeout.
                if (isMounted) {
                    setDialedDown(false);
                }
            });
        return () => {
            isMounted = false;
        };
    }, []);

    return dialedDown;
};

export default useIsCsvExportDialedDown;



// WEBPACK FOOTER //
// ./src/commons/hooks/useIsCsvExportDialedDown.js